<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
      <div class="">
        <vs-card>
          <vs-row class="w-full">

             <!-- <pre>{{callListdata}}</pre> -->
              <vs-col class="p-1 lg:w-1/3 md:w-1/2 sm:w-full w-full" v-for="callData in callListdata" :key="callData.id">
               
                <vs-card class="call-card h-full" >
                  <div slot="header" class="flex flex-wrap justify-between items-center">
                    <h5>Call History {{callData.id}}</h5>
                    <div class="flex">
                      <vs-button
                        type="border"
                        color="primary"
                        icon="edit"
                        class="mr-1"
                        @click="openEditForm(callData.id)"
                      ></vs-button>
                      <vs-button
                        type="border"
                        color="danger"
                        icon="delete"
                        @click="DeleteCall(callData.id)"
                      >
                      </vs-button>
                    </div>
                  </div>
                  <vs-row>
                    <vs-col
                      vs-type="flex"
                      vs-lg="6"
                      vs-sm="12"
                    >
                      <h6>Call Type</h6>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-lg="6"
                      vs-sm="12"
                    >
                      {{ callData.call_type }}
                    </vs-col>
                    <vs-col vs-type="flex" vs-lg="6"
                        vs-sm="12">
                      <h6>Course Purchase</h6>
                    </vs-col>
                    <vs-col vs-lg="6"
                        vs-sm="12">
                      <span v-for="item in callData.course" :key="item.id">
                        {{ item.name }},
                      </span>
                    </vs-col>
                  </vs-row>
                   <h5 v-if="callData.files.length">Files</h5>
                   <div class="flex flex-wrap">

                  
                  <div class="call_data_files mx-1 cursor-pointer" v-for="item in callData.files" :key="item">
                    <div class="image"  v-if="item.file_type === 'image/jpeg' || item.file_type === 'image/png'">
                     <img  @click="downloadImage(item)" :src="item.file_path">
                    </div> 
                     <div class="text"   @click="downloadImage(item)" v-else-if="item.file_type === 'text/plain'">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-word" class="svg-inline--fa fa-file-word fa-w-12" role="img" viewBox="0 0 384 512"><path fill="currentColor" d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"/></svg>
                    </div>
                    <div class="pdf"   @click="downloadImage(item)"  v-else-if="item.file_type === 'application/pdf'">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-pdf" class="svg-inline--fa fa-file-pdf fa-w-12" role="img" viewBox="0 0 384 512"><path fill="currentColor" d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"/></svg>
                    </div>
                    <div class="excel"   @click="downloadImage(item)" v-else-if="item.file_type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'">
                     <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-excel" class="svg-inline--fa fa-file-excel fa-w-12" role="img" viewBox="0 0 384 512"><path fill="currentColor" d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"/></svg>
                    </div>
                    <div class="text"   @click="downloadImage(item)" v-else-if="item.file_type === 'video/mp4'">
                      <video class="cstm-card-img" :src="item.file_path"></video>
                    </div>
                    <div class="general"   @click="downloadImage(item)" v-else>
                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-alt" class="svg-inline--fa fa-file-alt fa-w-12" role="img" viewBox="0 0 384 512"><path fill="currentColor" d="M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"/></svg>
                    </div>
                  </div>
                   </div>
                  <vs-divider class="mb-0" />

                  <div class="flex flex-wrap justify-between items-center pt-4">
                    <div>
                      <small class="block">
                        <b>Created By:</b> 
                        {{ callData.created_by }}
                      </small>
                      <small class="block">
                        <b>Created At:</b>
                        {{ callData.created_at }}
                      </small>
                    </div>
                    <vs-button
                        type="border"
                        color="success"
                        @click="downloadBulkImage(callData.files)"
                        icon-pack="feather"
                        icon="icon-download"
                        ></vs-button>
                  </div>
                </vs-card>         
              </vs-col>           
          </vs-row>
          <infinite-loading
          @infinite="infiniteHandler"
          spinner="circles"
          >
            <div slot="no-results"></div>

          </infinite-loading>
        </vs-card>
          <vs-popup
   
    color="primary"
    title="Edit call"
    :active.sync="editform"
  >
    <!-- Edit Form -->
    <form class="sidebar-scrollable-form">
      <div class="form-holder">
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" class="p-1">
            <label class="vs-input--label">Call Type</label>
            <vs-input class="w-full" v-model="editedCall.call_type" />
          </vs-col>
          <vs-col vs-lg="12" vs-sm="12" class="p-1">
            <label class="vs-input--label">Purchase to</label>
            <v-select
              class="w-full"
              multiple
              :reduce="(option) => option.id"
              label="name"
              :closeOnSelect="false"
              v-model="editedCall.course_ids"
              :options="courseLists"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" class="p-1">
            <label class="vs-input--label">Description</label>
            <vs-textarea
              label="Write Description here..."
              v-model="editedCall.description"
              height="200px"
            />
          </vs-col>
        </vs-row>
        <file-upload v-if="filesRecieved"
          class="file-upload"
          section_type="CourseComponent"
          :multiplefile="true"
          :file_repository_id="repository_id"
          @getFileId="getFileId"
          :filesInfo="filesInfo"
          @deletedIndex="deletedIndex"
        ></file-upload>
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" class="p-1">
            <label class="vs-input--label">Feedback</label>
            <vs-textarea
              v-validate="'required'"
              placeholder="Start typing the details about the task...."
              v-model="editedCall.feedback"
            />
          </vs-col>
        </vs-row>
      </div>

      <div class="footer-sidebar" slot="footer">
        <!-- Save & Cancel Button -->
        <div class="flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-auto mt-2"
            @click="closeEditForm"
            type="border"
            color="danger"
            >Cancel</vs-button
          >
          <vs-button class="ml-4 mt-2" @click.prevent="updateCall"
            >Save</vs-button
          >
        </div>
      </div>
    </form>
  </vs-popup>
        
      </div>
</template>
<script>
import {
  AddCallLogApi,
  fetchCallLogApi,
  FetchSingleCallId,
  UpdateCallLog,
  DeleteCallLog
} from '@/api/addcallLog'
import FileUpload from './callFileUpload'
import { courseListing } from '@/api/course-builderapi'
import { repository } from '@/mixins/repository.js'
import { PaginationData } from '@/mixins/pagination'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Editor from '@tinymce/tinymce-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import axios from 'axios'

export default {
  props: {
    leadId: {
      required: true
    },
    calladd: {
      required: false,
      type: Object,
      default: () => null
    }
    // notesdata:{
    //   type: Array,
    //   default: () => []
    // }
  },
  mixins: [PaginationData, repository],
  components: {
    editor: Editor,
    VuePerfectScrollbar,
    vSelect,
    FileUpload,
    flatPickr
  },
  data () {
    return {
      feedback: '',
      courses: [],
      files: [],
      courseLists: [],
      addform: false,
      editform: false,
      call_type: '',

      //task todo//

      description: '',

      //editedform
      editedCall: {
        description: '',
        file_ids: [],
        course_ids: [],
        call_type: '',
        feedback: ''
      },
      courserForlist: [],

      //editedform

      //tasktodo
      call_id: '',
      page: 1,
      filesInfo: [],
      filesRecieved:false,
      callListdata: [],
      sidebarCallMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      //taskpage

      //boolean
      //leadid
      dataId: null,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  async  created () {
    await this.fetchCallLog()
    await this.fetchCourseList()
    await this.getRepositoryId(1)
   
  },
  watch: {
    
    calladd:{
      deep:true,
      handler () {
        if (this.calladd.length > 0) {
          this.callListdata.unshift(this.calladd)
          console.log('hi')
        }
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeCallSidebar', false)
        }
      }
    },

    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    downloadBulkImage (item) {
      item.forEach(element => {
        axios({
          url: `${element.file_path}`,
          method: 'GET',
          responseType: 'blob',
          headers: {'Access-Control-Allow-Origin': '*'}

        }).then((response) => {
          const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileUrl

          fileLink.setAttribute('download', element.file_name)
          document.body.appendChild(fileLink)

          fileLink.click()
        }) 
      })
    },
    downloadImage (item) {
     
      axios({
        url: `${item.file_path}`,
        method: 'GET',
        responseType: 'blob',
        headers: {'Access-Control-Allow-Origin': '*'}

      }).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileUrl

        fileLink.setAttribute('download', item.file_name)
        document.body.appendChild(fileLink)

        fileLink.click()
      }) 
    },
    initValues () {
      if (this.data.id) return
      this.notescontent = ''
    },
    openAddForm () {
      this.editform = false
      this.addform = true
    },
    closeAddForm () {
      this.addform = false
    },
    closeEditForm () {
      this.editform = false
    },
    openEditForm (id) {
      this.fetchSingleForm(id)
    },
    async fetchSingleForm (id) {
      try {
        this.$vs.loading({
          text: 'Please Wait ...'
        })
        const { data } = await FetchSingleCallId(id)
        
        this.call_id = id
        this.editedCall.call_type = data.data.call_log_details.call_type
        const course = data.data.call_log_details.course.map((ele) => {
          return ele.id
        })
        this.editedCall.course_ids = course
        this.editedCall.description = data.data.call_log_details.description
        this.editedCall.feedback = data.data.call_log_details.feedback
        this.filesInfo = data.data.call_log_details.files
        
        this.files = data.data.call_log_details.files.map((ele) => {
          return ele.files_id
        })
        this.filesRecieved = true
        this.editform = true
        this.$vs.loading.close()
      } catch (e) {
        
      }
    },
    submitData () {
      const customerId = this.$store.getters.customerId
      const payload = {
        course_ids: this.courses,
        call_type: this.call_type,
        description: this.description,
        feedback: this.feedback,
        file_ids: this.files
      }
      
      this.addCallLog(payload, customerId, this.leadId)
      //this.initValues()
    },
    //fetch_course_list
    async fetchCourseList () {
      try {
        this.$vs.loading({
          text: 'Please Wait ...'
        })
        const payload = {}

        payload.custom = 0

        const customer_id = this.$store.getters.customerId

        const queryParams = this.$route.query || {}
        this.query_page.page = queryParams.page || 1
        const responeList = await courseListing(
          customer_id,
          payload,
          this.query_page.page
        )
        
        this.courseLists = responeList.data.data.courselist
        this.meta = responeList.data.data.meta

        
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }
    },
    getFileId (obj) {
      if (Array.isArray(obj)) {
        this.files = [...this.files, ...obj]
      } else {
        this.files.push(obj)
      }
    },
    deletedIndex (deleteIndex) {
      this.files.splice(deleteIndex, 1)
      this.filesInfo.splice(deleteIndex, 1)
    },
    //fetch_customer_list
    async addCallLog (payload, customer_id, leadId) {
      try {
        const { data } = await AddCallLogApi(payload, customer_id, leadId)

        const newData = data.data.call_log
        

        this.$emit('closeCallSidebar', 'New Call Log Added Successfully')
      } catch (e) {}
    },
    async fetchCallLog () {
      const customerId = this.$store.getters.customerId

      const { data } = await fetchCallLogApi(
        this.page,
        this.leadId,
        customerId
      )
      
      this.callListdata = data.data.call_list
      // if (this.calladd.length != 0) {
      //   this.callListdata.unshift(this.calladd)
      // }     
      this.courserForlist = data.data.call_list

      this.sidebarCallMeta = data.data.meta

      
    },
    initdefault () {
      this.title = ''
      this.description = ''
      this.related_to_id = []
      this.colloaborator_id = []
    },
    updateCall () {
      const payload = this.editedCall
      
      // payload.collaborator_id = this.editedCall.collaborator_id.map(({ user_id }) => user_id)

      // payload.collaborator_id = this.editedCall.collaborator_id.map(ele => ele.user_id)
      
      payload.file_ids = this.files
      this.updateData(this.editedCall, this.call_id)
    },
    async updateData (payload, id) {
      try {
        const { data } = await UpdateCallLog(payload, id)
        this.callListdata.forEach((element, index) => {
          if (element.id === id) {
            this.callListdata[index].call_type = payload.call_type
            this.callListdata[index].description = payload.description
            this.callListdata[index].feedback = payload.feedback
            this.callListdata[index].files = data.data.call.files
            this.callListdata[index].course = data.data.call.course
          }
        })
        this.$emit('closeCallSidebar', 'Call Log Updated Successfully')

        
      } catch (error) {
        
      }

      this.editform = false
      // 
    },
    infiniteHandler ($state) {
      if (this.sidebarCallMeta.has_next) {
        fetchCallLogApi(this.page + 1, this.leadId, this.$store.getters.customerId).then(({ data }) => {
          this.callListdata.push(...data.data.call_list)
          this.sidebarCallMeta = data.data.meta

          
          this.page++
          //increment of page

          if (!this.sidebarCallMeta.has_next) {
            $state.complete()
          } else {
            $state.loaded()
          }
        })
      } else {
        $state.complete()
        
      }
    },
    DeleteCall (id) {
      this.deleteCall(id)
    },
    async deleteCall (id) {
      this.editform = false
      this.addform = false
      const data = await DeleteCallLog(id)
      const dlt_id = this.callListdata.findIndex((item) => item.id === id)
      this.callListdata.splice(dlt_id, 1)
      const msg = data.data.message
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
      
    },
    handleCloseSidebar () {
      this.isSidebarActiveLocal = false
      document.body.classList.remove('overflow-hidden')
    }
  }
}
</script>

<style lang="scss" scoped>
.flatpickr-input[readonly] {
  cursor: pointer;
  width: 100%;
}
// [dir] .flatpickr-input[readonly] {
//     width: 100%;
// }

.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    //z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    // z-index: 52010;
    width: 550px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: scroll;
  }
}
[dir] .vs-content-sidebar.items-no-padding .vs-sidebar--items form {
  overflow-y: auto;
  height: calc(100vh - 195px);
}
body {
  margin: 0;
}
</style>

<style>
.call_data_files .image img{
  width:20px;
  height: 25px;
}
.call_data_files .pdf svg{
  color:red;
}
.call_data_files .general svg{
  color:aqua
}
.call_data_files .excel svg{
  color:green;
}
.call_data_files .text svg{
  color:blue;
}
.call_data_files svg{
  width:20px;
  
}
.add-new-data-sidebar .vs-sidebar-position-right {
  width: 480px !important;
  max-width: 480px !important;
}
.heading-holder {
  width: 80%;
}
.call-card .vs-card--content {
  margin-bottom: 0;
}
@media (max-width: 575px) {
  .add-new-data-sidebar .vs-sidebar-position-right {
    width: 80% !important;
    max-width: 480px !important;
  }
}
</style>